
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.545 0H1.364C.614 0 0 .614 0 1.364v9.545h1.364V1.364h8.181V0zm2.046 2.727h-7.5c-.75 0-1.364.614-1.364 1.364v9.545c0 .75.614 1.364 1.364 1.364h7.5c.75 0 1.364-.614 1.364-1.364V4.091c0-.75-.614-1.364-1.364-1.364zm-7.5 10.91h7.5V4.09h-7.5v9.545z","fill":"#585858"}})])
          )
        }
      }
    